import { Component, OnInit } from '@angular/core';
import { AngularTokenService } from '@lakshvairav/angular-token';
import { KeyValue } from './shared/key-value';
import { environment } from '../environments/environment';
import { AuthorizationService } from './shared/authorization.service';
import { Router } from '@angular/router';
import { WebsocketService } from './shared/websocket.service';
import * as ActionCable from 'actioncable';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app works!';
  selectedSession: any;
  cable: any;
  animStatus: any;
  constructor(private _tokenService: AngularTokenService,
    public authService: AuthorizationService, private router: Router,
    private KeyValueService: KeyValue, private websocketService:WebsocketService) {
    // console.log('calling init');

    // this._tokenService.init({
    //   apiBase: environment.base_url
    // });

    KeyValue.animStatus.subscribe(
      data => {
        // console.log('listening .... '+data);
        data === 'start' ? KeyValue.startAnim() : KeyValue.endAnim()
      }
    )
  }

  logout() {
    // this.router.navigate([KeyValue.signinPath])
    this.authService.logout();
  }

  initWebChannel() {
    console.log('Socket initialization for Auth Channel');
    const that = this;
    let ws;
    let retryCount = 0;
    const maxRetries = 3;

    function setupWebSocket() {
        ws = new WebSocket(environment.chat_base_url);

        ws.onopen = function() {
            console.log("WebSocket connection opened");
            ws.send(JSON.stringify({"command": "subscribe","identifier":"{\"channel\":\"AuthChannel\"}"}));
            retryCount = 0; // Reset retry count on successful connection
        };

        ws.onmessage = function(msg) {
            const data1 = JSON.parse(msg.data);
            if (data1.message !== undefined) {
                that.websocketService.wsocketAction(data1);
            }
        };

        ws.onerror = function(err) {
            console.error("WebSocket encountered error:", err);
        };

        ws.onclose = function(event) {
            console.log("WebSocket connection closed", event);
            if (retryCount < maxRetries) {
                const timeout = (retryCount + 1) * 10 * 1000; // Calculate timeout as (retryCount + 1) * 10 seconds
                console.log(`WebSocket connection lost, retrying in ${timeout / 1000} seconds... (attempt ${retryCount + 1} of ${maxRetries})`);
                retryCount++;
                setTimeout(setupWebSocket, timeout); // Attempt to reconnect after calculated timeout
            } else {
                console.log("Maximum retries reached. Stopping further connection attempts.");
            }
        };
    }

    // Initial setup
    setupWebSocket();

    // Network status listener
    window.addEventListener('offline', function() {
        console.log("Network went offline");
        if (ws && ws.readyState === WebSocket.OPEN) {
            ws.close(); // Close WebSocket when network goes offline
        }
    });

    window.addEventListener('online', function() {
        console.log("Network is back online");
        retryCount = 0; // Reset retry count
        setupWebSocket(); // Reconnect WebSocket immediately when network is back online
    });
}

 initWebChannel1() {
    console.log('socket initialization for Auth Channel');
    try {
      if (window.location.pathname.search('print-decision-forms') != -1) {
      } else {
        this.cable = ActionCable.createConsumer(environment.chat_base_url);
        this.cable.subscriptions.create("AuthChannel", {
          connected() {
            console.log("AuthChannel Subscription is ready for use");
          },
          disconnected() {
            console.log("AuthChannel Service terminated by server");
          },
          received: (data: any) => {
            this.websocketService.wsocketAction(data);
          }
        })
      }
    } catch (e) {
      console.log('...inside catch exception')
      console.log(e);
    }
  }
  ngOnInit() {
    //  console.log('init called');
    KeyValue.animStatus_update('end');
    let that = this;
    setTimeout(function(){that.initWebChannel()},9000);

    if (this._tokenService.userSignedIn()) {
      if(this._tokenService.currentUserData==null){
        this._tokenService.validateToken().subscribe(
          res =>      {
            console.log('....'+ JSON.stringify(res));
            localStorage.setItem('currentUserData',JSON.stringify(res));
          },
          error =>    {
            console.log(error);
          }
        );

      }      
      if(this.authService.logoutTimerStarted === false) {
        this.authService.logoutTimerStarted = true;
        this.authService.startTimer(1800000 * 1);
      }
    }
  }

}
